import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles"; // Import ThemeProvider and createTheme
import Home from "./components/Home";
import Thankyou from "./components/Thankyou";
import Layout from "./components/Layout";
import "./fonts.css"; // Assuming this file contains your custom font setup
import "./index.css";
// Create the theme object
const theme = createTheme({
  typography: {
    fontFamily: "'SF Pro Display', 'Poppins', 'Roboto', 'Arial', sans-serif",
    h1: {
      fontWeight: "bold",
      fontFamily: "SF Pro Dsipaly, Poppins, sans-serif",
    },
    body1: {
      fontWeight: "normal",
      fontFamily: "SF Pro Dsipaly, Poppins, sans-serif",
    },
    // Customize other typography styles here
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/thank-you" element={<Thankyou />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}
